import React from "react";
import logo from "../assets/images/Logo.png";

const Loader = ({ height = "50", width = "50" }) => {
  return (
    <div role="status" className="flex justify-center items-center w-full h-[60vh]">
      <div className="relative flex items-center justify-center w-24 h-24">
        {/* Outer Spinner (Clockwise) */}
        <div 
          className="absolute inset-0 rounded-full border-[3px] border-transparent border-t-[#37783A] border-b-[#37783A] opacity-90 animate-spin"
        ></div>
        
        {/* Inner Spinner (Counter-clockwise) */}
        <div 
          className="absolute inset-1.5 rounded-full border-[3px] border-transparent border-l-[#a1b8a1] border-r-[#a1b8a1] opacity-90"
          style={{ animation: 'spin 1.2s linear infinite reverse' }}
        ></div>

        {/* Logo in Center */}
        <img 
          src={logo} 
          alt="Loading..." 
          className="w-10 h-10 object-contain z-10 mt-2"
        />
      </div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default Loader;
